import React from "react";
import RailServicePage from "./RailServicePage";

export default function TrainBooking() {
  return (
    <RailServicePage
      eyebrow="Train Booking"
      title="Book train tickets with confidence"
      description="Search rail routes, compare available options, and get support for Amtrak, VIA Rail, and city-to-city train travel."
      icon="booking"
      highlights={[
        {
          title: "Simple route search",
          text: "Enter your departure and arrival stations, choose travel dates, and compare rail options in one place.",
        },
        {
          title: "Advisor support",
          text: "Get help with ticket rules, passenger details, schedule choices, and booking questions before you confirm.",
        },
      ]}
      steps={[
        "Search your origin, destination, travel date, and passenger count.",
        "Compare train options by timing, route, estimated fare, and provider.",
        "Call our booking advisors for final availability and ticket support.",
      ]}
    />
  );
}
